import { IState } from './iState';

export const initialState: IState = {
  servers: [],
};
